import React from 'react';
import { Globe2 } from 'lucide-react';
import { formatFa } from './constants';
import { continentMetaList } from './regionMeta';
import type { CompanionRegionFilter } from './types';

type CompanionsRegionExplainerProps = {
  activeRegion: CompanionRegionFilter;
  filteredCount: number;
  onRegionChange: (region: CompanionRegionFilter) => void;
};

const CompanionsRegionExplainer: React.FC<CompanionsRegionExplainerProps> = ({
  activeRegion,
  filteredCount,
  onRegionChange,
}) => {
  const activeMeta =
    activeRegion === 'همه'
      ? null
      : continentMetaList.find((m) => m.region === activeRegion);

  return (
    <div className="cp-stories-regions">
      <div className="cp-stories-regions__header">
        <div className="text-right">
          <p className="cp-stories-eyebrow">
            <Globe2 className="h-3.5 w-3.5" />
            توزیع جغرافیایی
          </p>
          <h2 className="cp-stories-regions__title">شهرها بر اساس قاره</h2>
          {activeMeta && (
            <p className="cp-stories-regions__desc" style={{ borderRightColor: activeMeta.tone }}>
              {activeMeta.description}
            </p>
          )}
        </div>
        <div className="cp-stories-regions__stat">
          <span className="cp-stories-regions__stat-value">{formatFa(filteredCount)}</span>
          <span className="cp-stories-regions__stat-label">شهر در نمای فعلی</span>
        </div>
      </div>

      <div className="cp-stories-regions__pills">
        {continentMetaList.map((meta) => {
          const selected = activeRegion === meta.region;
          return (
            <button
              key={meta.region}
              type="button"
              onClick={() => onRegionChange(meta.region)}
              className={`cp-region-pill ${selected ? 'cp-region-pill--active' : ''}`}
            >
              <span className="cp-region-pill__count">{formatFa(meta.cityCount)}</span>
              <span className="cp-region-pill__name">{meta.region}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CompanionsRegionExplainer;
